module.exports = __webpack_public_path__ + "media/images/sp/plans/search_form/location_type_studio_3column-9ddc0a338427c493e9d33c566bce8872.webp";